<form [formGroup]="form">
  <table>
    <tbody class="inner">
      <tr>
        <td>&nbsp;</td>
        <td>
          @if (!newRow) {
            <span>{{selected.Location}}</span>
          }
          <select id="Location"
            formControlName="Location" required
            class="form-control"
            [ngClass]="classname[LOCATION]"
            title="{{header[LOCATION].label}}"
            (change)="onLocationChange($event)">
            @for (v of locations; track v) {
              <option value="{{v.ComponentSubSystemID}}">{{v.Description}}</option>
            }
          </select>
          @if (!newRow) {
            <button type="button" class="btn btn-default" title="Undo changes" [disabled]="isundodisabled[LOCATION] == true" (click)="onLocationUndo()">
              <span class='glyphicon glyphicon-arrow-left'></span>
            </button>
          }
        </td>
        <td>
          @if (!newRow) {
            <span>{{selected.Component}}</span>
          }
          <select id="Component"
            formControlName="Component" required
            class="form-control"
            [ngClass]="classname[COMPONENT]"
            title="{{header[COMPONENT].label}}"
            (change)="onComponentChange()">
            @for (v of components; track v) {
              <option value="{{v.ComponentItemID}}">{{v.Description}}</option>
            }
          </select>
          @if (!newRow) {
            <button type="button" class="btn btn-default" title="Undo changes" [disabled]="isundodisabled[COMPONENT] == true" (click)="onComponentUndo()">
              <span class='glyphicon glyphicon-arrow-left'></span>
            </button>
          }
        </td>
        <td>&nbsp;</td>
        <td>
          <button type="button"
            class="btn btn-warning"
            (click)="onRowCancel()">
            Cancel
          </button>
        </td>

      </tr>
    </tbody>
  </table>
</form>